// src/components/common/PasswordInput.jsx — Universal Accessible Password Field with Eye Toggle
import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./passwordInput.css";

export default function PasswordInput({
  id,
  name,
  value,
  onChange,
  placeholder = "Enter password",
  label,
  required = false,
  autoComplete = "current-password",
  disabled = false,
  error,
  helperText,
  style = {}
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="crm-password-field-wrap" style={style}>
      {label && (
        <label htmlFor={id || name} className="crm-password-label">
          {label} {required && <span className="crm-req-star">*</span>}
        </label>
      )}

      <div className={`crm-password-input-box ${error ? "has-error" : ""}`}>
        <input
          id={id || name}
          name={name}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          autoComplete={autoComplete}
          disabled={disabled}
          className="crm-password-input"
        />

        <button
          type="button"
          tabIndex={0}
          className="crm-password-eye-btn"
          onClick={() => setShowPassword(prev => !prev)}
          aria-label={showPassword ? "Hide password" : "Show password"}
          title={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>

      {error ? (
        <span className="crm-password-error-text">{error}</span>
      ) : helperText ? (
        <span className="crm-password-helper-text">{helperText}</span>
      ) : null}
    </div>
  );
}
